module.exports = __webpack_public_path__ + "img/Active (2).8c180fdf.svg";